"use strict";

exports.__esModule = true;
exports.omitInternalProps = omitInternalProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable */
function omitInternalProps(props) {
  var className = props.className,
      style = props.style,
      src = props.src,
      width = props.width,
      height = props.height,
      fittingType = props.fittingType,
      renderMode = props.renderMode,
      quality = props.quality,
      format = props.format,
      blur = props.blur,
      isOnScreen = props.isOnScreen,
      otherProps = _objectWithoutProperties(props, ["className", "style", "src", "width", "height", "fittingType", "renderMode", "quality", "format", "blur", "isOnScreen"]);

  return otherProps;
}